(() => {
  if (window.msxNavigationReady) return;
  window.msxNavigationReady = true;
  const selector = '.msx-products-menu, .msx-mobile-products, .msx-mobile-menu';
  const sync = (menu) => {
    menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
    menu.closest('.msx-nav-disclosure')?.classList.toggle('is-open', menu.open);
  };
  const close = (menu, focus = false) => {
    menu.open = false;
    sync(menu);
    if (focus) menu.querySelector(':scope > summary')?.focus();
  };
  const closeOthers = (active) => {
    document.querySelectorAll(selector).forEach((menu) => {
      if (menu !== active && !menu.contains(active) && !active.contains(menu)) close(menu);
    });
  };
  const enhance = (menu) => {
    if (menu.dataset.msxMenuReady) return;
    menu.dataset.msxMenuReady = 'true';
    const summary = menu.querySelector(':scope > summary');
    if (!summary) return;
    const wrapper = menu.closest('.msx-nav-disclosure') || menu;
    const hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    let timer;
    const clearTimer = () => window.clearTimeout(timer);
    const open = () => { clearTimer(); closeOthers(menu); menu.open = true; sync(menu); };
    sync(menu);
    summary.addEventListener('click', () => { clearTimer(); closeOthers(menu); });
    menu.addEventListener('toggle', () => sync(menu));
    if (wrapper !== menu) {
      wrapper.addEventListener('pointerenter', () => { if (hover.matches) open(); });
      wrapper.addEventListener('pointerleave', () => {
        clearTimer();
        if (hover.matches && !wrapper.contains(document.activeElement)) timer = window.setTimeout(() => close(menu), 140);
      });
      wrapper.addEventListener('focusout', (event) => {
        if (!wrapper.contains(event.relatedTarget)) { clearTimer(); close(menu); }
      });
      wrapper.querySelector(':scope > a')?.addEventListener('click', () => { clearTimer(); close(menu); });
    }
    wrapper.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        event.stopPropagation();
        clearTimer();
        close(menu, true);
      } else if (event.key === 'ArrowDown' && wrapper !== menu && (event.target === summary || event.target === wrapper.querySelector(':scope > a'))) {
        event.preventDefault();
        open();
        menu.querySelector('.msx-products-menu__panel a')?.focus();
      }
    });
  };
  const initialize = (scope = document) => scope.querySelectorAll(selector).forEach(enhance);
  document.addEventListener('click', (event) => {
    document.querySelectorAll(selector).forEach((menu) => {
      const wrapper = menu.closest('.msx-nav-disclosure') || menu;
      if (menu.open && !wrapper.contains(event.target)) close(menu);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const menu = event.target.closest('.msx-products-menu, .msx-mobile-products');
    if (menu) { closeOthers(menu); menu.open = true; sync(menu); }
  });
})();
